import { Component, OnChanges, input, ChangeDetectionStrategy } from "@angular/core";
import { NgClass, NgStyle } from "@angular/common";

@Component({
	selector: "stages-progress-bar",
	templateUrl: "./progress-bar.html",
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [NgClass, NgStyle],
})
export class ProgressBarComponent implements OnChanges {
	readonly progress = input<number>();

	readonly iconClass = input<string>();

	width?: string;

	ngOnChanges(): void {
		const progress = this.progress();
		this.width = String(Math.round(progress ? progress * 100 : 0)) + "%";
	}
}
